import React from 'react'
import { instrukcjaImportuURL } from '../../lib/consts'
import styled from 'styled-components'

const ImportCSVInfoStyle = styled.div`
  a {
    color: #0079c4;
    text-decoration: none;
  }
`

const ImportCSVInfo = (
  <ImportCSVInfoStyle>
    Poniższe zestawienie możesz wypełnić ręcznie. Możesz też zaimportować dane z
    pliku CSV (jak przygotować taki plik, dowiesz się z{' '}
    <a href={instrukcjaImportuURL} target="_blank" rel="noopener noreferrer">
      instrukcji
    </a>
    ). W obu przypadkach część pól zostanie automatycznie obliczona w oparciu o
    formuły wbudowane w zestawienie.
  </ImportCSVInfoStyle>
)

export default ImportCSVInfo
